import { Link } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";
import useDevice from "@hooks/use_device.ts";
import "./back_button.scss";
import BackIcon from "@sprout/icons/back.tsx";

const BackButton = ({ href }: { href?: string }) => {
  const { t } = useTranslation("misc");
  const device = useDevice();

  return (
    <div className="flex">
      <Link href={href || "/dashboard"}>
        <div className="flex items-center gap-1 ">
          {device.isWeb ? (
            <span className="flex items-center gap-2">
              <BackIcon size="sm" color="green" />
              {t("back")}
            </span>
          ) : (
            <BackIcon />
          )}
        </div>
      </Link>
    </div>
  );
};

export default BackButton;
